import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class DataLayerService  {

  private dataLayer;

  constructor() {
    this.createDataLayer();
  }

  public createDataLayer() {
    (window as any).dataLayer = (window as any).dataLayer || [];
    this.dataLayer = (window as any).dataLayer;
  }
  
  public pushToDataLayer(object) {
    object = this.parseStringObject(object);
    this.dataLayer.push(object);
  }

  public pushManyToDataLayer(objects) {
    objects.forEach(object => {
      object = this.parseStringObject(object);
      this.dataLayer.push(object);
    });
  }

  private parseStringObject(object) {
    if (typeof object.data_layer_event === 'string') {
      try {
        return  JSON.parse(object.data_layer_event)
      } catch (error) {}
    }
    return object;
  }

  public clearDataLayer() {
    this.dataLayer = [];
  }

  public clearEcommerce() {
    this.dataLayer.push({ ecommerce: null });
  }

}
